import { TranslationWithDescriptionDTO } from "../../dto/TranslationWithDescriptionDTO";

export type CourseTranslationStatus =
  | "ready"
  | "name_missing"
  | "not_translated";

/**
 * Only the name blocks publishing (see CheckIsInputInvalid in PublishCourseHook),
 * but an empty language reads differently from a half-filled one, so the two are
 * reported separately.
 */
export const getCourseTranslationStatus = (
  dto: TranslationWithDescriptionDTO
): CourseTranslationStatus => {
  const hasName = !!dto.name?.trim();
  const hasDescription = !!dto.description?.trim();

  if (!hasName && !hasDescription) return "not_translated";
  if (!hasName) return "name_missing";
  return "ready";
};

/**
 * Languages that are not ready. This is also exactly what "Translate missing"
 * would fill, so the footer hint and the button badge share one number.
 */
export const countNeedingAttention = (
  translations: TranslationWithDescriptionDTO[]
): number =>
  translations.filter((t) => getCourseTranslationStatus(t) !== "ready").length;
